/* assets/pdp-gallery-reset.js — v2 (Aug 2026)
   NMM fix: PDP media gallery could restore on the wrong slide after
   tab-discard reloads / session restores (browser re-applies the
   slider's inner scrollLeft after theme init). v2 changes after
   live-site verification found v1 was a no-op:
   1. scrollTo({behavior:'instant'}) — a bare scrollLeft assignment
      is ignored under this slider's scroll-behavior:smooth +
      scroll-snap-type:x mandatory CSS.
   2. Featured slide index is captured once at script parse, when the
      server-rendered HTML is authoritative (.is-active can be stale
      at correction time on a restored/resurrected document).
   3. GA event fires only if the observed position actually moved to
      the target — never on the attempt alone.
   4. Interaction guard re-arms on every pageshow (a latched flag from
      a previous visit must not block correction on a restored page).
   Note: this store has no variant-assigned media (verified across all
   products via products.json), so featured slide == server .is-active
   in all current cases; ?variant= links remain safe because the index
   is read from the server-rendered document each fresh parse.
*/
(function () {
  'use strict';

  var gallery = document.querySelector('media-gallery .main-image carousel-slider');
  if (!gallery) return; // not a PDP, or single-image product

  var slider = gallery.querySelector('.slider');
  if (!slider) return;

  // Captured at parse: fresh server HTML marks the correct featured slide.
  var items = slider.querySelectorAll('.slider__item');
  var featuredIndex = 0;
  for (var i = 0; i < items.length; i++) {
    if (items[i].classList.contains('is-active')) { featuredIndex = i; break; }
  }

  var userHasInteracted = false;
  var interactionEvents = ['pointerdown', 'wheel', 'touchstart', 'keydown'];

  function markInteracted() { userHasInteracted = true; }

  function armInteractionGuard() {
    userHasInteracted = false;
    interactionEvents.forEach(function (type) {
      window.addEventListener(type, markInteracted, { once: true, passive: true });
    });
  }

  function reportCorrection(evt) {
    try {
      var nav = performance.getEntriesByType('navigation')[0];
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'pdp_gallery_position_corrected',
        navigation_type: nav ? nav.type : 'unknown', // navigate | reload | back_forward
        bfcache_restored: !!(evt && evt.persisted)
      });
    } catch (e) { /* monitoring only — never break the gallery */ }
  }

  function resetGallery(evt) {
    var slides = slider.querySelectorAll('.slider__item');
    var featured = slides[featuredIndex];
    if (!featured) return;

    var reported = false;

    var apply = function () {
      if (userHasInteracted) return; // never fight the user
      var target = featured.offsetLeft;
      var before = slider.scrollLeft;
      if (Math.abs(before - target) < 2) return; // already correct

      slider.scrollTo({ left: target, behavior: 'instant' });

      // Report only if the write demonstrably took effect.
      requestAnimationFrame(function () {
        if (!reported && Math.abs(slider.scrollLeft - target) < 2) {
          reported = true;
          reportCorrection(evt);
        }
      });
    };

    // Browsers apply (and can re-apply) scroll restoration asynchronously
    // as lazy content loads, so correct now and re-check briefly after.
    apply();
    requestAnimationFrame(apply);
    setTimeout(apply, 250);
    setTimeout(apply, 1000);
  }

  // pageshow fires on normal loads AND snapshot restores (persisted=true).
  window.addEventListener('pageshow', function (evt) {
    armInteractionGuard();
    resetGallery(evt);
  });
})();